import { PlaceScanFlow } from '../components/PlaceScanFlow'
import { StoreScreen } from '../components/StoreScreen'

/** F5.3 — Put away: scan the place label, then each bag (and seals at the sample store). */
export function PutAwayPage() {
  return (
    <StoreScreen title="store.putAway">
      {(state) => <PlaceScanFlow state={state} mode="PUT_AWAY" />}
    </StoreScreen>
  )
}
